import { render, staticRenderFns } from "./role-permission-list.vue?vue&type=template&id=19b6a50b&scoped=true"
import script from "./role-permission-list.vue?vue&type=script&lang=js"
export * from "./role-permission-list.vue?vue&type=script&lang=js"
import style0 from "./role-permission-list.vue?vue&type=style&index=0&id=19b6a50b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b6a50b",
  null
  
)

export default component.exports